import { NativeElementMixin } from './native-element-mixin';
import { PropertiesMixin } from './properties-mixin';
import { RendererMixin, html } from './renderer-mixin';
import { EventMixin } from './event-mixin';
// FcElememt which similar to LitElement API with support for older browsers
class FcElement extends EventMixin(
  RendererMixin(PropertiesMixin(NativeElementMixin))
) {}

// HACK: gets Rollup to include the index
const ELEMENT_MODULE = 'element';
export { ELEMENT_MODULE, FcElement, html };
